import React from 'react';
import { Box, Loader } from 'monday-ui-react-core';

function Loading() {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px'
      }}
    >
      <Loader size={Loader.sizes.MEDIUM} />
    </Box>
  );
}

export default Loading; 